// 使用量（pm_usage_daily）の月の区切り。DB の日付は日本時間（food-label-assist の supabase/migrations/v5_usage_jst_date.sql の pm_increment_usage）
// なので、画面の「今月」も日本時間で決める。以前は new Date(y, m, 1).toISOString() で求めており、日本時間の端末では
// UTC に直した前日（9/30 等）になって、今月の集計に前月の末日が入っていた（全般のコードレビュー、2026-10-12）。
// food-label-assist の src/utils/jstMonth.js と同じ。サーバーの月間上限（api/_usage.js の jstMonthStart）も同じ決め方
const JST_YEAR_MONTH = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit' });

// 'YYYY-MM'（日本時間の今月）
export function jstYearMonth(now = new Date()) {
  const parts = Object.fromEntries(JST_YEAR_MONTH.formatToParts(now).map(p => [p.type, p.value]));
  return `${parts.year}-${parts.month}`;
}

// 'YYYY-MM-01'（日本時間の今月の 1 日）
export function jstMonthStart(now = new Date()) {
  return `${jstYearMonth(now)}-01`;
}

// 'YYYY-MM' の翌月の 1 日（'YYYY-MM-01'）。タイムゾーンに依らない文字列の計算
export function nextMonthStart(yearMonth) {
  const [y, m] = String(yearMonth).split('-').map(Number);
  const ny = m === 12 ? y + 1 : y;
  const nm = m === 12 ? 1 : m + 1;
  return `${ny}-${String(nm).padStart(2, '0')}-01`;
}
